import i18n from 'i18next';
import backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .use(backend)
  .init({
    load: 'languageOnly',
    ns: ['translation', 'errors'],
    fallbackLng: false,
    lng: 'en',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    backend: {
      loadPath: '{{lng}}/{{ns}}',
      parse: data => data,
      async request(opts, url, payload, cb) {
        const [lng, ns] = url.split('/');
        let data = null;
        let status = null;
        try {
          const pkg = await import(`./${lng}.json`);
          data = pkg.default[ns];
          status = 200;
        } catch (err) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(err);
          }
          status = 404;
        } finally {
          cb(null, { data, status });
        }
      },
    },
  });

export default i18n;
